import '@/assets/styles/tailwind.css'
import '@/assets/styles/root.scss'

import { ConfirmationService } from 'primevue'
import Tooltip from 'primevue/tooltip'
import { createApp } from 'vue'

import setup from '@/setup.ts'

import App from './App.vue'

const app = createApp(App)
setup(app)

app.use(ConfirmationService)
app.directive('tooltip', Tooltip)
app.mount('#app')
